import { render, staticRenderFns } from "./trialBalanceArchiveTop.vue?vue&type=template&id=1472d586&scoped=true"
import script from "./trialBalanceArchiveTop.vue?vue&type=script&lang=js"
export * from "./trialBalanceArchiveTop.vue?vue&type=script&lang=js"
import style0 from "./trialBalanceArchiveTop.vue?vue&type=style&index=0&id=1472d586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472d586",
  null
  
)

export default component.exports